export default {"src":"/_next/static/media/sourcream.8e9b3ba4.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};